module.exports = __webpack_public_path__ + "img/breitenberg.91c3f7f9.jpg";